import { Routes, RouterModule } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { LoginComponent } from "./login/login.component";
import { AddressesUrlParams } from "../parameters/addresses-url-params";
import { IndexComponent } from "./index/index.component";
import { DonacionesComponent } from "./donaciones/donaciones.component";

export const childRoutes: Routes = [
  {
    path: AddressesUrlParams.LOGIN,
    component: LoginComponent
  }, 
  {
    path: AddressesUrlParams.PAGES_HOME,
    component: PagesComponent,
    children: [
      {
        path: AddressesUrlParams.PAGE_DONACIONES,
        component: DonacionesComponent
      },                  
      //{ path: "", redirectTo: AddressesUrlParams.LOGIN, pathMatch: "full" },
      { path: "index", component: IndexComponent }
    ]
  }
];

export const routing = RouterModule.forChild(childRoutes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts